export const DailyCash = () => import("./DailyCash.vue");
export const DailyCashCreate = () => import("./DailyCashCreate.vue");
